import axios from 'axios';

type Options = {
  q: string;
  query_by?: string[];
  page?: number;
  per_page?: number;
  projectTypes?: string[];
};

export async function makeIndexedInsightsHubSearchRequest({
  q,
  page,
  per_page,
  query_by,
  projectTypes,
}: Options) {
  const endpoint =
    process.env.IS_PRODUCTION_APP === 'true'
      ? '/collections/articles/documents/search/'
      : '/collections/articles-draft/documents/search/';

  const payload: Record<string, string> = {
    q,
    query_by: query_by?.join(',') ?? 'title,content,summary,preview',
    per_page: `${per_page ?? '20'}`,
    page: `${page ?? '1'}`,
    sort_by: '_text_match:desc,published_date:desc',
    query_by_weights: '4,1,1,1',
    prioritize_exact_match: 'true',
  };

  // Website-only posts must never appear in platform search. Applied
  // unconditionally, not inside the Compass branch: the previous guard lived in an
  // else arm, so it only ever covered non-Compass users, and was removed wholesale
  // when it broke their search. Requires the indexer to populate is_public_only
  // (serverless-functions#6, deployed and reindexed).
  const filters: string[] = ['is_public_only:false'];
  if (projectTypes && projectTypes.length > 0) {
    // Match Strapi: (visibility != subscriber_only) OR (subscriber_only with null/matching project_types)
    // Using num_project_types:=0 to check for empty project_types array
    const projectTypesStr = projectTypes.map((type) => `"${type}"`).join(',');
    filters.push(
      `(is_subscriber_only:false || (is_subscriber_only:true && (num_project_types:=0 || project_type:[${projectTypesStr}])))`
    );
  }

  payload.filter_by = filters.join(' && ');

  const queryString = new URLSearchParams(payload).toString();

  const res = await axios.get(`${process.env.TYPESENSE_URL}${endpoint}?${queryString}`, {
    headers: {
      'X-TYPESENSE-API-KEY': process.env.TYPESENSE_API_KEY,
    },
  });

  return res.data?.hits;
}
